import {Model, BaseModel} from "../data";
import {Mixin} from "../common/mixwith";


/**
 * This mixin binds a Model class or instance to any Component and keep all attributes
 * from the component instance synchronized.
 *
 */
export const ModelBindingMixin = Mixin((superclass) => class extends superclass {

  /**
   *
   * @param config
   */
  constructor(config = {}) {
    super($.extend(true, {
      on: {
        'before:init': '_initModel'
      },
      model: {
        data: null,
        class: Model,
        options: {},
      },
    }, config));
  }

  /**
   * Initialize a new model instance from the class defined in config
   * or take the model in data config if exists.
   * @private
   */
  _initModel() {
    /**
     * Model instance
     * @type {BaseModel}
     */
    this.model = this.config.data;
    if (!this.model) {

      // support array for model class with multiple arguments
      if (Array.isArray(this.config.model.options)) {
        this.model = new this.config.model.class(...this.config.model.options);
      }
      else {
        this.model = new this.config.model.class(this.config.model.options);
      }
    }
    if ((!this.model instanceof BaseModel)) {
      throw "Invalid config in ModelBinding: data must be a Model class."
    }
    this.model.on('change', this.syncModel.bind(this));
    this.model.on('sync:done', this.syncModel.bind(this));
  }

  /**
   * Passes model data to Component's set function.
   * @param {BaseModel} model - model instance
   * @private
   */
  syncModel(model) {
    this.set(model.getData());
  }

});